import type { DeepPartial, MessageCatalog } from './types';

const ky: DeepPartial<MessageCatalog> = {
  nav: {
    home: 'FalaRus',
    partner: 'Сүйлөшүү',
    teachers: 'Мугалимдер',
    stats: 'Статистика',
    profile: 'Профиль',
  },
  profile: {
    tapPhoto: 'Сүрөттү тандоо үчүн басыңыз',
    premiumDaysLeft: 'Premium · {{days}} күн калды',
    groups: {
      personal: 'Жеке',
      settings: 'Жөндөөлөр',
      help: 'Жардам',
    },
    rows: {
      profile: 'Профиль',
      certificates: 'Сертификаттар',
      invite: 'Досторду чакыруу',
      textSize: 'Тексттин өлчөмү',
      notifications: 'Эскертмелер',
      darkMode: 'Караңгы режим',
      language: 'Тил',
      sound: 'Үн жана титирөө',
      help: 'Жардам',
      pricing: 'Тарифтер',
      paymentHistory: 'Төлөм тарыхы',
      logout: 'Чыгуу',
    },
    firstName: 'Аты',
    lastName: 'Фамилиясы',
    save: 'Сактоо',
    cancel: 'Жокко чыгаруу',
    nameUpdated: 'Аты жаңыртылды',
    avatarUpdated: 'Профиль сүрөтү жаңыртылды',
    avatarUploadFailed: 'Сүрөт жүктөлбөй калды',
    nameRequired: 'Аты жана фамилиясы толтурулушу керек',
  },
  common: {
    user: 'Колдонуучу',
    save: 'Сактоо',
    cancel: 'Жокко чыгаруу',
  },
  language: {
    selectTitle: 'Тилди тандаңыз',
    selectSubtitle: 'Интерфейстин тили',
  },
  auth: {
    benefits: {
    },
    register: 'Катталуу',
    logIn: 'Кирүү',
    logInTitle: 'Кирүү',
    createAccountTitle: 'Катталуу',
    phone: 'Телефон',
    email: 'Email',
    password: 'Сырсөз',
    createPassword: 'Сырсөз ойлоп табыңыз',
    rewritePassword: 'Сырсөздү кайра киргизиңиз',
    name: 'Аты',
    surname: 'Фамилиясы',
    emailHint: 'username@gmail.com',
    forgotPassword: 'Сырсөздү унуттуңузбу?',
    or: 'ЖЕ',
    continueWithGoogle: 'Google аркылуу улантуу',
    noAccount: 'Аккаунтуңуз жокпу? ',
    signUp: 'Катталуу',
    haveAccount: 'Аккаунтуңуз барбы? ',
    emailRequired: 'Email киргизилиши керек',
    emailInvalid: 'Email туура эмес',
    phoneInvalid: 'Телефон номери туура эмес',
    passwordRequired: 'Сырсөз киргизилиши керек',
    passwordMinLength: 'Сырсөз кеминде 6 белгиден турушу керек',
    passwordsMismatch: 'Сырсөздөр дал келбейт',
    nameRequired: 'Аты киргизилиши керек',
    surnameRequired: 'Фамилиясы киргизилиши керек',
    termsPrefix: 'Аккаунт ачуу менен мен ',
    termsOfUse: 'Колдонуу шарттары',
    termsAnd: ' жана ',
    privacyPolicy: 'Купуялык саясаты',
    termsSuffix: ' менен макулмун.',
    resetTitle: 'Сырсөздү калыбына келтирүү',
    resetSubtitle: 'Email дарегиңизге жаңы сырсөз жөнөтөбүз',
    resetSendPassword: 'Жаңы сырсөз жөнөтүү',
    resetSuccessTitle: 'Email жөнөтүлдү',
    resetSuccessSubtitle: 'Эгер аккаунт бар болсо, жаңы сырсөз email дарегиңизге жөнөтүлдү',
    networkError: 'Интернет байланышы жок. Кайра аракет кылыңыз.',
    genericError: 'Ката кетти',
  },
};

export default ky;
